export interface UnitOption {
    label: string;
    value: string;
}

export const MEASUREMENT_UNITS: UnitOption[] = [
    // Weight/Mass
    { label: 'kg', value: 'kg' },
    { label: 'g', value: 'g' },
    { label: 'mg', value: 'mg' },
    { label: 'mcg', value: 'mcg' },

    // Volume
    { label: 'L', value: 'L' },
    { label: 'mL', value: 'mL' },
    { label: 'μL', value: 'μL' },

    // Concentration - Molar
    { label: 'mmol/L', value: 'mmol/L' },
    { label: 'μmol/L', value: 'μmol/L' },
    { label: 'mEq/L', value: 'mEq/L' },
    { label: 'mOsm/kg', value: 'mOsm/kg' },

    // Concentration - Mass
    { label: 'ng/mL', value: 'ng/mL' },
    { label: 'mg/dL', value: 'mg/dL' },
    { label: 'g/dL', value: 'g/dL' },
    { label: 'μg/dL', value: 'μg/dL' },
    { label: 'pg/mL', value: 'pg/mL' },

    // Enzyme Activity
    { label: 'IU/L', value: 'IU/L' },
    { label: 'U/L', value: 'U/L' },
    { label: 'μIU/mL', value: 'μIU/mL' },

    // Length/Distance
    { label: 'cm', value: 'cm' },
    { label: 'mm', value: 'mm' },
    { label: 'm', value: 'm' },

    // Temperature
    { label: '°C', value: '°C' },
    { label: '°F', value: '°F' },

    // Percentage
    { label: '%', value: '%' },

    // Pressure
    { label: 'mmHg', value: 'mmHg' },
    { label: 'kPa', value: 'kPa' },
    { label: 'cmH2O', value: 'cmH2O' },

    // Rate/Frequency
    { label: 'bpm', value: 'bpm' },
    { label: 'mL/min', value: 'mL/min' },

    // Time
    { label: 'years', value: 'years' },
    { label: 'days', value: 'days' },
    { label: 'hours', value: 'hours' },
    { label: 'min', value: 'min' },
    { label: 'sec', value: 'sec' },

    // Dimensionless
    { label: 'score', value: 'score' },
    { label: 'ratio', value: 'ratio' },
    { label: 'index', value: 'index' },

    // Specialized Clinical Units
    { label: 'copies/mL', value: 'copies/mL' },
    { label: 'cells/μL', value: 'cells/μL' },
    { label: 'fL', value: 'fL' },
    { label: 'mm3', value: 'mm3' },

    // Area
    { label: 'cm2', value: 'cm2' },
    { label: 'm2', value: 'm2' },
];
